import React, { useState } from "react";
import Modal from "./Modal";
import Icon from "../Icon/Icon";
import { getLastApiError } from "../../core/api";
import { sendErrorReport } from "../../core/errorReport";
import s from "./ModalAlert.module.scss";

/**
 * Esito di un'operazione (come ModalAlert di gestionale-gls): in caso di
 * errore l'utente può mandare il report con un click, e il report porta con
 * sé l'ultima chiamata API fallita.
 */
export default function ModalAlert({ isError = true, title, message, errorData, onClose }) {
  const [report, setReport] = useState("idle");

  const send = async () => {
    setReport("sending");
    try {
      await sendErrorReport({ modalText: message, errorData, apiError: getLastApiError() });
      setReport("sent");
    } catch {
      setReport("error");
    }
  };

  return (
    <Modal onClose={onClose} size="sm">
      <div className={s.wrap}>
        <span className={`${s.icon} ${isError ? s.iconError : ""}`}>
          <Icon name={isError ? "info" : "check"} size={30} strokeWidth={2} />
        </span>
        <h2 className={s.title}>{title || (isError ? "Ops... qualcosa è andato storto" : "Perfetto!")}</h2>
        {message && <p className={s.text}>{message}</p>}
        {isError ? (
          report === "sent" ? (
            <>
              <p className={s.sent}>Report inviato. Grazie!</p>
              <button type="button" className="pr-btn pr-btn-confirm pr-btn-block" onClick={onClose}>
                Chiudi
              </button>
            </>
          ) : (
            <div className={s.actions}>
              <button type="button" className="pr-btn pr-btn-cancel" onClick={onClose}>
                Chiudi
              </button>
              <button type="button" className="pr-btn pr-btn-confirm" onClick={send} disabled={report === "sending"}>
                {report === "sending" ? "Invio in corso..." : report === "error" ? "Riprova invio" : "Invia report"}
              </button>
            </div>
          )
        ) : (
          <button type="button" className="pr-btn pr-btn-confirm pr-btn-block" onClick={onClose}>
            Avanti
          </button>
        )}
      </div>
    </Modal>
  );
}
